export type ErrorMessages = Record<string, string> & { __isErrorMessages: true };

export function createErrorMessageTypeGuard<ErrorCode extends string>() {
   return function (messages: Record<ErrorCode | 'default', string>): ErrorMessages {
      return messages as ErrorMessages;
   };
}
